// extracted by mini-css-extract-plugin
export default {"productDetailHeader":"ProvinceCard_productDetailHeader__cW7FC","icons":"ProvinceCard_icons__VxN2B"};